// [@vidstack/eliza] THIS FILE IS AUTO GENERATED - SEE `eliza.config.ts`

import "../../define/vds-slider-value-text.js";
import * as React from "react";
import { createComponent } from "../lib/index.js";
import { SliderValueTextElement } from "../../ui/slider/index.js";

const EVENTS = {} as const;

/** Outputs the current slider value as text. */
const SliderValueText = createComponent(
  React,
  "vds-slider-value-text",
  SliderValueTextElement,
  EVENTS,
  "SliderValueText"
);

export default SliderValueText;
